'use strict';

export default {
  adminProperties: {
    settings: {
      options: {
        options: 'Options',
        default: 'Défaut',
        order: 'Ordre',
      },
    },
    fields: {
      common: {
        text: 'Titre',
        textColor: 'Couleur du titre',
        hiddenText: 'Titre caché',
        required: 'Requis',
        visible: 'Visible',
        enabled: 'Activé',
        excludeFromReport: 'Exclut du rapport',
        placeholder: 'Texte de support',
        defaultValue: 'Valeur par défaut',
      },
      acknowledgment: {
        defaultValue: 'Valeur par défaut',
      },
      birthdate: {
        defaultValue: 'Date par défaut',
      },
      checkbox: {
        defaultValue: 'Valeur par défaut',
      },
      date: {
        defaultValue: 'Date par défaut',
      },
      datetime: {
        defaultValue: 'Date par défaut',
      },
      documentViewer: {
        defaultValue: 'Lien',
        documentName: 'Nom du document',
        documentType: 'Type du document',
      },
      email: {
        defaultValue: 'E-mail par défaut',
      },
      embeddedPhoto: {
        defaultValue: "Lien de l'image",
        alt: 'Texte alt',
      },
      longText: {
        min: 'Longueur min.',
        max: 'Longueur max.',
        defaultValue: 'Valeur par défaut',
      },
      numeric: {
        min: 'Min',
        max: 'Max',
        decimals: 'Nombre de décimales',
        defaultValue: 'Valeur par défaut',
      },
      optionList: {
        multiSelection: 'Permettre la selection multiple',
      },
      rating: {
        starsColor: 'Couleur des étoiles',
        starCount: "Nombre d'étoiles",
        allowHalfStar: "Permettre les moitiés d'étoile",
        defaultValue: 'Note par défaut',
      },
      staticText: {
        defaultValue: 'Texte statique',
      },
      text: {
        min: 'Longueur min.',
        max: 'Longueur max.',
        defaultValue: 'Valeur par défaut',
      },
      time: {
        defaultValue: 'Temps par défaut',
      },
      toggle: {
        defaultValue: 'Valeur par défaut',
      },
      video: {
        videoPlayer: 'Lecteur de vidéo',
        videoLink: 'Lien du vidéo',
      },
      weblink: {
        defaultValue: 'Lien',
      },
      yesNo: {
        allowNa: 'Permettre le N/A',
        defaultValue: 'Valeur par défaut',
      },
      paymentZone: {
        providers: 'Fournisseurs',
        options: 'Options',
        choices: 'Choix',
      },
    },
  },
};
